import { Skeleton } from "@mui/material";

/**
 * Componente para exibir 'loading state' quando os pedidos estão sendo carregados.
 * @constructor
 */
export default function OrderSkeleton() {
  return (<>
      <Skeleton
        variant="text"
        sx={{ width: "80%" }}
        animation="wave"
      />
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          borderRadius: "7px", width: "100%", height: { xs: "180px", sm: "200px", md: "280px" },
        }}
      />
    </>);
}